import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { breakpoints, device } from "../../../utils/responsive_utilities";
import { white, whiteLilac } from '../../../components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';
import { moveElementHorizontally } from "../../../../../landing-pages/js/common/functions/animations";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #090A4A;
  ${styledFont("Graphie")}
  padding: 8.6rem 0 7rem 0;

  @media ${device.Desktop}{
    padding: 8.6rem 0 20rem 0;
  }
  /* @media ${device.TabletLandscape}{
    padding: 8.6rem 0 7rem 0;
  }
  @media ${device.Tablet}{
    padding-bottom: 7.7rem;
  }
  @media ${device.PhoneTabletLandscape}{
    padding-bottom: 8.5rem;
  } */
`

export const HeadingText = styled.h2`
  color: ${white};
  width: 34.2rem;
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 3.2, 3.8, 7)}
  text-align: center;
  @media ${device.Tablet}{
    width: 60%;
  }
  
  @media ${device.Desktop}{
    ${styledFont("Graphie", 4.8, 6.4, 7)}
    width: 68.2rem;
  }

  @media ${device.TabletLandscape}, ${device.Tablet}, ${device.PhoneTabletLandscape}{
    width: 52.3rem;
  }

`

export const HighlightText = styled.span`
  color: #4F52C3;
`

export const PlayableWrapper = styled.div`
  margin: 6.7rem 0 8.1rem 0;

  @media ${device.Tablet}{
    margin: 4.4rem 0 3.7rem 0;
  }

  @media ${device.Desktop}{
    margin: 3.4rem 0 7rem 0;
  }
  
`

export const PlayableGroupFirst = styled.div`
  transform: rotate(-4deg);
  margin-bottom: 1.6rem;

  > img{
    height: 100%;
    max-width: unset;
    width: calc(100% + 16rem);
    animation: ${moveElementHorizontally({x1: -10, x2: -7})} 2s linear 1 forwards;
  }

  @media (min-width:${breakpoints.md}px){
    height: 100%;
    >img{
      max-width: unset;
      width: calc(100% + 18rem);
      height: 100%;
      animation: ${moveElementHorizontally({x1: -7, x2: 1})} 2s linear 1 forwards;
      margin-bottom: 3.2rem;
    }
  }

  @media ${device.TabletLandscape}{
    >img{
      height: 14.3rem;
    }
  }
  @media ${device.Tablet}{
    >img{
      height: 10.3rem;
    }
  }
  @media ${device.PhoneTabletLandscape}{
    >img{
      height: 12.3rem;
    }
  }
`

export const PlayableGroupSecond = styled.div`
  transform: rotate(-4deg);
  max-width: unset;

  > img{
    height: 100%;
    max-width: unset;
    width: calc(100% + 14rem);
    animation: ${moveElementHorizontally({x1: -10, x2: -13})} 2s linear 1 forwards;
  }

  @media (min-width:${breakpoints.md}px){
    height: 100%;
    >img{
      max-width: unset;
      width: calc(100% + 18rem);
      height: 100%;
      animation: ${moveElementHorizontally({x1: -1, x2: -10})} 2s linear 1 forwards;
    }
  }
  @media ${device.TabletLandscape}{
    >img{
      height: 14.3rem;
    }
  }
  @media ${device.Tablet}{
    >img{
      height: 10.3rem;
    }
  }
  @media ${device.PhoneTabletLandscape}{
    >img{
      height: 12.3rem;
    }
  }
`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  /* padding-bottom: 7.8rem; */
  >div {
    width: 25.2rem;
  }
  /* @media ${device.Desktop}{
    padding-bottom: 5rem;
  }
  @media ${device.TabletLandscape}{
    padding-bottom: 5.6rem;
  }
  @media ${device.Tablet}{
    padding-bottom: 7.7rem;
  }
  @media ${device.PhoneTabletLandscape}{
    padding-bottom: 8.5rem;
  } */
`